import React from 'react';
import {
    Switch,
    Route,
    useLocation,
} from 'react-router-dom';
import withRoot from '../../wiring/with-root';

import Header from '../../components/header';
import Footer from '../../components/footer';

import Home from '../../routes/home';

import themer from '../../styles/material-theme';

const PublicLayout = () => {
    const location = useLocation();

    return (
        <>
            <Header />
            <main>
                <Switch location={location}>
                    <Route path="/">
                        <Home />
                    </Route>
                </Switch>
            </main>
            <Footer />
        </>
    );
};

export default withRoot(PublicLayout, themer);
